module.exports = __webpack_public_path__ + "img/dov_yes.6a167f38.png";